function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: i , size: e = 24  } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = s(), t = i !== null && i !== void 0 ? i : n ? a.colors.inverse : a.colors.neutralHigh, { skinName: l  } = c();
    return l.match(/^blau/i) ? /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ r("path", {
            fill: t,
            d: "M21.786 20.786l-5.893-5.893a7.84 7.84 0 001.821-5.036C17.714 5.536 14.18 2 9.857 2 5.536 2 2 5.536 2 9.857c0 4.322 3.536 7.857 7.857 7.857a7.84 7.84 0 005.036-1.821l5.893 5.893a.705.705 0 00.5.214.705.705 0 00.5-.214.69.69 0 000-1zM3.429 9.857c0-3.536 2.892-6.428 6.428-6.428s6.429 2.892 6.429 6.428-2.893 6.429-6.429 6.429c-3.536 0-6.428-2.893-6.428-6.429z"
        })
    })) : l.match(/^o2/i) ? /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ r("path", {
            fill: t,
            d: "M15.701 14.884l5.62 5.896a.744.744 0 01-.004 1.012.662.662 0 01-.96 0l-5.62-5.9c-1.299 1.136-2.967 1.82-4.785 1.82-4.126 0-7.482-3.524-7.482-7.856S5.826 2 9.952 2c4.127 0 7.487 3.524 7.483 7.86 0 1.908-.651 3.66-1.733 5.024zM9.953 3.428c-3.375 0-6.122 2.884-6.122 6.428s2.747 6.428 6.122 6.428c3.376 0 6.123-2.884 6.123-6.428s-2.747-6.428-6.123-6.428z"
        })
    })) : /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ r("path", {
            fill: t,
            d: "M10.021 17.83A7.846 7.846 0 014.472 4.435a7.848 7.848 0 0111.473 10.677l5.704 5.704a.561.561 0 01-.793.793l-5.697-5.697a7.792 7.792 0 01-5.138 1.918zm0-14.571A6.726 6.726 0 005.265 14.74a6.728 6.728 0 009.512-.036 6.724 6.724 0 000-9.473 6.672 6.672 0 00-4.756-1.972z"
        })
    }));
}, u = h;
export { u as default };
